var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4515",
    filter: "url(#filter0_d_1_335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 38.5,
    stroke: "#5B73E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 40677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.1865 60.2494C35.8282 60.0229 33.6263 59.1784 31.7666 57.8604C33.0176 60.138 35.0705 61.9152 37.5423 62.8101L38.1865 60.2494Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.9895 57.0392L34.3711 53.1805C32.3636 52.3664 30.5583 51.1544 29.0547 49.6416C30.1869 54.0859 34.0975 57.4318 38.8199 57.7132L38.9895 57.0392Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.4308 48.4024C32.9215 46.8919 34.2624 45.8465 35.8469 45.7389L42.8101 45.2668L43.3239 43.9872C35.0544 41.3678 29.5104 30.1847 29.4484 30.0575C29.1857 29.5175 28.5853 29.2304 27.9999 29.365C27.4146 29.4997 27 30.0208 27 30.6212V38.4406C27 42.7674 29.0741 46.6183 32.2797 49.053C32.3113 48.8351 32.361 48.6175 32.4308 48.4024Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.8223 60.2496L60.4665 62.8104C62.9388 61.9157 64.992 60.1382 66.2432 57.8604C64.3832 59.1785 62.1809 60.0231 59.8223 60.2496Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M63.6252 53.1813L59.0078 57.0391L59.1774 57.7133C63.9002 57.4324 67.8113 54.0863 68.9437 49.6416C67.4396 51.1548 65.6335 52.3672 63.6252 53.1813Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M69.9993 29.3652C69.414 29.2299 68.8133 29.5177 68.5508 30.0577C68.4887 30.1856 62.9569 41.373 54.6748 43.9891L55.1879 45.2669L62.1509 45.739C63.7356 45.8466 65.0765 46.8921 65.5672 48.4024C65.6372 48.6178 65.6869 48.8356 65.7184 49.0538C68.9245 46.6191 70.999 42.7679 70.9991 38.4407V30.6214C70.9991 30.0209 70.5844 29.4999 69.9993 29.3652Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M63.1186 49.1988C62.9559 48.698 62.5051 48.3466 61.9798 48.3109L53.402 47.7293L50.1982 39.7511C50.002 39.2626 49.5284 38.9424 49.002 38.9424C48.4755 38.9424 48.0019 39.2626 47.8058 39.7511L44.602 47.7293L36.0242 48.3109C35.499 48.3466 35.0481 48.698 34.8854 49.1988C34.7228 49.6994 34.8808 50.2488 35.2849 50.5862L41.8827 56.0987L39.7851 64.4365C39.6566 64.947 39.8516 65.4844 40.2775 65.7938C40.5029 65.9575 40.7687 66.04 41.0353 66.04C41.2728 66.04 41.5106 65.9745 41.7207 65.8427L49.0022 61.2714L56.2836 65.8427C56.7295 66.1225 57.3008 66.1033 57.7267 65.7939C58.1526 65.4844 58.3476 64.9471 58.2191 64.4365L56.1216 56.0987L62.7193 50.5862C63.1231 50.2487 63.2812 49.6994 63.1186 49.1988ZM49.9146 54.5202C49.6748 54.76 49.3422 54.8975 49.0028 54.8975C48.6642 54.8975 48.3316 54.76 48.0918 54.5202C47.8512 54.2796 47.7137 53.9478 47.7137 53.6085C47.7137 53.269 47.8512 52.9365 48.0918 52.6967C48.3316 52.4569 48.6633 52.3194 49.0028 52.3194C49.3422 52.3194 49.6748 52.4569 49.9146 52.6967C50.1543 52.9373 50.2918 53.269 50.2918 53.6085C50.2918 53.9478 50.1543 54.2797 49.9146 54.5202Z",
    fill: "#27B783"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_335",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_335",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premiumPlan.a6faa34e98ad075af46282cc5d2ec8e9.svg";
export { ForwardRef as ReactComponent };